var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 8.75V10.625C14.375 11.7853 13.9141 12.8981 13.0936 13.7186C12.2731 14.5391 11.1603 15 10 15C8.83968 15 7.72688 14.5391 6.90641 13.7186C6.08594 12.8981 5.625 11.7853 5.625 10.625V8.75H4.375V10.625C4.37566 12.0082 4.88591 13.3426 5.80826 14.3733C6.73062 15.4041 8.0004 16.0588 9.375 16.2125V17.5H6.875V18.75H13.125V17.5H10.625V16.2125C11.9996 16.0588 13.2694 15.4041 14.1917 14.3733C15.1141 13.3426 15.6243 12.0082 15.625 10.625V8.75H14.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75C10.8288 13.75 11.6237 13.4208 12.2097 12.8347C12.7958 12.2487 13.125 11.4538 13.125 10.625V4.375C13.125 3.5462 12.7958 2.75134 12.2097 2.16529C11.6237 1.57924 10.8288 1.25 10 1.25C9.1712 1.25 8.37634 1.57924 7.79029 2.16529C7.20424 2.75134 6.875 3.5462 6.875 4.375V10.625C6.875 11.4538 7.20424 12.2487 7.79029 12.8347C8.37634 13.4208 9.1712 13.75 10 13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicWhiteIcon);
export default __webpack_public_path__ + "static/media/mic-white-icon.323440abfdae2960c58e12c856cb347f.svg";
export { ForwardRef as ReactComponent };